import { CustomerTheme } from '@/modules/core/data/types/CustomerTheme';
import Icon from '@/common/components/dataDisplay/Icon';
import {
  css,
  useTheme,
} from '@emotion/react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import React from 'react';

type Props = {
  handleDownClick: () => void;
  handleUpClick: () => void;
}

/**
 * Vertical slider controls (up/down) buttons.
 *
 * @param props
 */
const VerticalSlider: React.FunctionComponent<Props> = (props): JSX.Element => {
  const {
    handleDownClick,
    handleUpClick,
  } = props;
  const theme: CustomerTheme = useTheme();
  const { primaryColor, onPrimaryColor } = theme;

  return (
    <div
      css={css`
        background-color: ${primaryColor};
        display: flex;
        width: 45px;
        margin: 20px 0px 20px -15px;
        flex-direction: column;
        border-radius: 9px;

        .arrow {
          background-color: transparent;
          border: none;
          color: ${onPrimaryColor};
          padding: 0;
          width: 24px;
          height: 24px;
          margin: 8px -3px 3px 0px;
        }

        .line-separator {
          background-color: ${onPrimaryColor};
          height: 1px;
          width: 25px;
          margin: 5px;
        }

        .slider {
          margin: 20px 8px 20px 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      `}
    >
      <div className={'slider'}>
        <button
          className={'arrow'}
          onClick={handleUpClick}
        >
          <Icon icon={ArrowUp} />
        </button>
        <div className={'line-separator'} />
        <button
          className={'arrow'}
          onClick={handleDownClick}
        >
          <Icon icon={ArrowDown} />
        </button>
      </div>
    </div>
  );
};

export default VerticalSlider;
